<template>
  <div v-if="items.filterName === 'propertyType'">
    <div
      v-for="item in itemOptions"
      :key="item.value"
      class="list"
      @click="selectItem(item)"
    >
      <div>
        <p :class="{ active: isActive(item.name, 'propertyType') }">
          {{ t(item.name.toLowerCase()) }}
        </p>
      </div>
      <div class="pi pi-chevron-right list-arrow"></div>
    </div>
  </div>
  <div
    v-if="computedAdditionalItems && items.filterName === 'city'"
    class="adjusted-size-list"
    @scroll="onScroll"
  >
    <div
      v-for="item in computedAdditionalItems"
      :key="item"
      class="list"
      @click="selectItem(item)"
    >
      <div class="body-bg">
        <p :class="{ active: isActive(item.cityId, 'cityIds') }">
          {{ item.cityName }}
        </p>
        <span class="caption">{{ item.provinceName }}</span>
      </div>
      <div class="pi pi-chevron-right list-arrow" />
    </div>
  </div>
  <div
    v-if="computedAdditionalItems && items.filterName === 'district'"
    class="adjusted-size-list"
  >
    <div
      v-for="item in computedAdditionalItems"
      :key="item"
      class="list"
      @click="selectItem(item)"
    >
      <div class="body-bg">
        <p :class="{ active: isActive(item.districtId, 'districtIds') }">
          {{ item.districtName }}
        </p>
      </div>
      <div class="pi pi-chevron-right list-arrow" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import { useComputedActiveFilters } from '@bd/components'
import { useI18n } from 'vue-i18n'
import { AdditionalFilter, FilterData } from '@bd/store-modules/types'
import { useAppStore } from '@bd/client/store'
import { useInfiniteScroll } from '@bd/components'

export default defineComponent({
  name: 'DashboardDropdownList',
  emits: ['dropdown-click', 'bottomReach'],
  props: {
    items: {
      type: Object as PropType<FilterData>,
      required: true,
    },
    additionalItems: {
      type: Array as PropType<AdditionalFilter[]>,
      required: false,
    },
  },
  setup(props, { emit }) {
    const i18n = useI18n()
    const store = useAppStore()
    const filtersActive = computed(() =>
      useComputedActiveFilters(store.state.offers?.searchedFilters || {}),
    )

    const selectItem = (item: AdditionalFilter) => {
      const value = item.value || item.cityId || item.districtId
      emit('dropdown-click', value)
    }
    const itemOptions = computed(() => {
      return props.items?.options ? props.items.options : []
    })
    const isActive = (itemValue: string, itemName: string) => {
      return filtersActive.value.some((x) =>
        x.children.find(
          (y) => y.name === itemName && y.value.includes(itemValue),
        ),
      )
    }

    const computedAdditionalItems = computed(() => props.additionalItems)

    const onScroll = useInfiniteScroll(() => {
      emit('bottomReach')
    })

    return {
      ...i18n,
      ...props,
      isActive,
      selectItem,
      itemOptions,
      filtersActive,
      onScroll,
      computedAdditionalItems,
    }
  },
})
</script>

<style lang="scss" scoped>
.adjusted-size-list {
  height: 325px;
  overflow-y: auto;
}

.list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid $athens-gray;
  height: 55px;
  background: #ffffff;
  p {
    color: $bright-gray;
  }
  &:hover {
    cursor: pointer;
    p {
      color: $primary-color;
    }
  }
  .active {
    color: $primary-color;
  }
  .list-arrow {
    justify-content: right;
    color: $primary-color;
  }
  &:nth-last-child(1) {
    border-bottom: none;
  }
}
</style>
